import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from '@/store/index'
import '@/styles/index.scss' // global css
import '@/plugins/index.js'
import 'animate.css';
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  router,
  store
}).$mount('#app')
